import { render, staticRenderFns } from "./compTopUpConfig.vue?vue&type=template&id=048b97be&scoped=true"
import script from "./compTopUpConfig.vue?vue&type=script&lang=js"
export * from "./compTopUpConfig.vue?vue&type=script&lang=js"
import style0 from "./compTopUpConfig.vue?vue&type=style&index=0&id=048b97be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b97be",
  null
  
)

export default component.exports